// -----------------------------------------------------------------------------
// PoolLex.io — Feature flags
// -----------------------------------------------------------------------------
// Centralised on/off switches for product surfaces that are NOT ready for the
// general public yet but whose code we want to keep alive in the repo (so we
// can reactivate without re-writing).
//
// How to flip a flag:
//   1. Change the boolean below
//   2. Commit + push
//   3. Railway redeploys automatically
//
// Future: replace this static file with a Mongo-backed admin toggle (panel
// /admin → Funcionalitats) so the flag can flip without a redeploy. The
// "useFeatureFlag" hook below is already designed to support that swap.
// -----------------------------------------------------------------------------

export const FEATURE_FLAGS = {
  /**
   * Visibilitat pública de la pàgina /mantenimiento-piscina (i la seva
   * variant /mantenimiento). Quan és `false`:
   *   - El link al header no es mostra
   *   - El link al footer no es mostra
   *   - La card del hub /profesionales no es mostra
   *   - L'URL directa redirigeix a /
   *
   * Per a reactivar quan vulguem obrir l'oferta a mantenidors:
   * canviar a `true` aquí (o, en el futur, fer el toggle al panel admin).
   */
  maintenanceServiceVisible: false,

  /**
   * Sprint 118.9 — Vertical B2G (Contratación Pública) en stand-by.
   * 26/10/2026 — REACTIVAT. Veure el bloc de sota.
   *
   * La reorientació 2026-07-29 (PoolLex = certificació sostenibilitat
   * EN 17645) demana enfocar tot cap a Ficha/Sello/Instaladors i evitar
   * missatges paral·lels que puguin confondre el visitant. Amb aquest flag
   * a `false`:
   *   - Header oculta l'entrada "Contratación Pública"
   *   - Landing V3 oculta §02 "Piscinas municipales" i §03 "La infraestructura"
   *   - La ruta /contratacion-publica segueix accessible directament per
   *     enllaç (repositori intern) però no es promociona des de cap CTA
   *
   * Per reactivar: canviar a `true` (el codi queda al repo intacte).
   *
   * 26/10/2026 — ENCÈS. El motiu de tenir-lo apagat era servir el gir a la
   * certificació de sostenibilitat, i aquell gir s'ha revisat: tres mesos
   * amb la norma voluntària al hero i la gent no se la treu si no és
   * obligatori. Apagant això vam apagar també el moat 🟢 —el conocimiento
   * municipal agregat— que el North Star diu que les landings han de fer
   * VISIBLE. Tornen els §02 i §03 de la landing i l'entrada B2G al header.
   */
  b2gVerticalVisible: true,

  /**
   * Sprint 119.10 — Secció "§04 Organizaciones adheridas" de /initiative
   * en stand-by. Fins que la iniciativa tingui una llista real de
   * supporters aprovats amb valor de prova social, no es mostra.
   * Amb aquest flag a `false`:
   *   - /initiative no renderitza la secció §04
   *   - No es fa la crida a /api/initiative/supporters
   * Endpoint backend intacte; només s'oculta el consum al front.
   *
   * Per reactivar: canviar a `true` (codi al repo intacte).
   */
  showAdheredOrgs: false,

  /**
   * Sprint 119.13 — Bloc destacat CE3X ("PoolLex.io es a piscinas
   * lo que CE3X es a edificios") a /initiative en stand-by. La
   * analogia queda guardada al codi i a memory per reutilitzar-la
   * en pitch decks / materials, però no es mostra públicament de
   * moment.
   *
   * Per reactivar: canviar a `true`.
   */
  showCE3XParallel: false,

  /**
   * Sprint 119.27 — Funcionalitat "Delivery Document" en stand-by.
   * Es valora com a possibilitat de pagament a futur. Amb aquest flag OFF:
   *   - /instaladores no mostra la card "Delivery Document" (benefits)
   *   - /instaladores no mostra el step 4 "Issue Documents" (how it works)
   *   - InstallerDashboard oculta el botó de descarrega del delivery cert
   * L'endpoint backend /pools/{id}/delivery-certificate segueix operatiu
   * per no trencar clients que ja l'hagin usat; simplement no es promociona.
   */
  deliveryDocumentVisible: false,
};

/**
 * Hook-like helper. Avui llegeix de la constant exportada. En el futur
 * podem fer-lo asíncron i llegir de l'API d'admin sense canviar els consumers.
 */
export function isFeatureEnabled(flagName) {
  return Boolean(FEATURE_FLAGS[flagName]);
}
